// Contents
import React, { useEffect, useState, useMemo, useContext } from 'react';
import PageHero from "../pageHero/PageHero_SingleProject.jsx";
import SingleProjectContent from "./projects/single/SingleProjectContent.jsx";
import SingleContact from "./projects/single/SingleContact.jsx";
import OtherProjectsSwiper from "./swiper/OtherProjectsSwiper.jsx";
import PageNotFound from "./PageNotFound.jsx";
import { supabase } from '../../utils/supabase.js';
import { RevealContext } from '../context/RevealContext.jsx';

export default function SingleProject({ navigate, lang })
{
    const slug = window.location.pathname;
    const { resetReveal } = useContext(RevealContext);

    const [projectRows, setProjectRows] = useState(null);
    const [translationRows, setTranslationRows] = useState(null);
    const [uiRows, setUiRows] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            supabase.from('projects').select('id, slug, info, image_list, image_swiper, swiper_show, agency, date, url, position, outils, images').order('position'),
            supabase.from('projects_translations').select('project_id, lang, title, content, agency'),
            supabase.from('projects_ui').select('key, fr, en'),
        ]).then(([projRes, transRes, uiRes]) => {
            if (projRes.data) setProjectRows(projRes.data);
            if (transRes.data) setTranslationRows(transRes.data);
            if (uiRes.data) setUiRows(uiRes.data);
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        if (!loading) resetReveal();
    }, [loading]);

    const uiMap = useMemo(() => {
        if (!uiRows) return null;
        const map = {};
        uiRows.forEach(r => { map[r.key] = { fr: r.fr, en: r.en }; });
        return map;
    }, [uiRows]);

    const allProjects = useMemo(() => {
        if (!projectRows || !translationRows) return [];
        return projectRows.map(p => {
            const trans = translationRows.find(t => t.project_id === p.id && t.lang === lang);
            return {
                ...p,
                imageList: p.image_list,
                imageSwiper: p.image_swiper,
                swiperShow: p.swiper_show,
                title: trans?.title ?? '',
                content: trans?.content ?? '',
                agency: trans?.agency ?? p.agency,
            };
        });
    }, [projectRows, translationRows, lang]);

    if (loading) return null;

    const found = allProjects.find(p => p.slug === slug);

    if (!found) {
        return <PageNotFound />;
    }

    const normalized = {
        ...found,
        image: Array.isArray(found.images) ? found.images.map(i => i.img) : (found.image || []),
        NbImage: Array.isArray(found.images) ? found.images.length : (found.NbImage || (found.image ? found.image.length : 0)),
    };

    return (<>
        <PageHero navigate={navigate} lang={lang} uiMap={uiMap} data={{ title: normalized.title, agency: normalized.agency, info: normalized.info, date: normalized.date, url: normalized.url }} />

        <SingleProjectContent key={lang} navigate={navigate} data={normalized} lang={lang} uiMap={uiMap} />

        <SingleContact lang={lang} navigate={navigate} uiMap={uiMap} />

        <OtherProjectsSwiper navigate={navigate} lang={lang} currentSlug={slug} allProjects={allProjects} uiMap={uiMap} />
    </>);
}